module.exports = __webpack_public_path__ + "img/consultor4.12b43ef2.png";